import { render, staticRenderFns } from "./EmployeeMoveModal.vue?vue&type=template&id=822db88c&"
import script from "./EmployeeMoveModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports